export default __webpack_public_path__ + "static/media/CarDetailingHeavyCutVOCFree.80e1993d.webp";